import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, Checkbox, Skeleton, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography, } from '@mui/material';
import { useState } from 'react';
import { Scrollbar } from '../scrollbar/scrollbar';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
// using function here because of an IDE linting error
export function StarjackTable({ items = [], allItems = items, columns, onDeselectAll, onSelectAll, itemId, onPageChange, onRowsPerPageChange, count = 0, rowsPerPage = 25, rowsSelectable = false, onSelect, onDeselect, loading = false, currentPage, onRowClick, noDataLabel, defaultSortColumn = '', defaultSortDirection = 'desc', selectRow, }) {
    const [page, setPage] = useState(currentPage || 0);
    const [selected, setSelected] = useState([]);
    const { t } = useTranslation();
    const selectedSome = selected.length > 0 && selected.length < items.length;
    const selectedAll = allItems.length > 0 && selected.length === allItems.length;
    const onSelectItem = (checked, item) => {
        if (checked) {
            const nextSelected = [...selected, item];
            setSelected(() => nextSelected);
            onSelect?.(item, nextSelected);
        }
        else {
            const currentSelected = [...selected];
            const index = currentSelected.findIndex((currentSelected) => currentSelected[itemId] === item[itemId]);
            if (index > -1) {
                currentSelected.splice(index, 1);
                setSelected(currentSelected);
                onDeselect?.(item, currentSelected);
            }
        }
    };
    return (_jsxs(Card, { sx: {
            width: '100%',
        }, children: [_jsx(Scrollbar, { children: _jsx(Box, { sx: { minWidth: 800 }, children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [rowsSelectable && (_jsx(TableCell, { padding: 'checkbox', children: _jsx(Checkbox, { checked: selectedAll, indeterminate: selectedSome, onChange: (event) => {
                                                    if (event.target.checked) {
                                                        setSelected(allItems);
                                                        onSelectAll?.(allItems);
                                                    }
                                                    else {
                                                        onDeselectAll?.();
                                                        setSelected([]);
                                                    }
                                                } }) })), columns.map(({ label, options, sortKey }, index) => (_jsx(TableCell, { ...options?.headerCellProps, children: _jsxs(Box, { sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }, children: [label, defaultSortColumn ===
                                                        sortKey && (_jsx(_Fragment, { children: defaultSortDirection ===
                                                            'asc' ? (_jsx(KeyboardArrowUpIcon, {})) : (_jsx(KeyboardArrowDownIcon, {})) }))] }) }, index)))] }) }), _jsx(TableBody, { children: loading ? (new Array(rowsPerPage)
                                    .fill(null)
                                    .map((value, index) => (_jsx(TableRow, { children: _jsx(TableCell, { colSpan: columns.length +
                                            (rowsSelectable ? 1 : 0), children: _jsx(Skeleton, { height: 40 }) }) }, index)))) : items.length ? (items.map((item, index) => {
                                    const isSelected = !!selected.find((selectedItem) => selectedItem[itemId] ===
                                        item[itemId]);
                                    const showAsSelected = selectRow?.(item, index) || false;
                                    return (_jsxs(TableRow, { hover: true, selected: isSelected, onClick: () => {
                                            if (!rowsSelectable) {
                                                onRowClick?.(item);
                                            }
                                        }, sx: {
                                            ...(!rowsSelectable && {
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                },
                                            }),
                                            ...(showAsSelected && {
                                                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                            }),
                                        }, children: [rowsSelectable && (_jsx(TableCell, { padding: 'checkbox', children: _jsx(Checkbox, { checked: isSelected, onChange: (event) => {
                                                        onSelectItem(event.target
                                                            .checked, item);
                                                    } }) })), columns.map(({ itemKey, itemTransform, options, }, index) => (_createElement(TableCell, { ...options?.rowCellProps, key: index },
                                                _jsxs(_Fragment, { children: [!!itemKey &&
                                                            item[itemKey], !itemKey &&
                                                            typeof itemTransform ===
                                                                'function'
                                                            ? itemTransform(item)
                                                            : ''] }))))] }, index));
                                })) : (_jsx(TableRow, { children: _jsx(TableCell, { align: 'center', sx: {
                                            p: 6,
                                        }, colSpan: columns.length +
                                            (rowsSelectable ? 1 : 0), children: _jsx(Typography, { sx: {
                                                fontWeight: 500,
                                            }, children: noDataLabel ||
                                                t('noEntriesAvailable') }) }) })) })] }) }) }), _jsx(TablePagination, { component: 'div', count: count, page: currentPage || page, onPageChange: (event, value) => {
                    setPage(value);
                    onPageChange(value);
                }, rowsPerPage: rowsPerPage, onRowsPerPageChange: (e) => {
                    onRowsPerPageChange?.(parseInt(e.target.value));
                }, rowsPerPageOptions: [5, 10, 25, 50], align: 'left' })] }));
}
